import { DownOutlined } from "@ant-design/icons";
import { Button, Col, Collapse, Modal, Row } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
import styles from "./DesiHands.module.scss";
import { empowerFutureData, faqData, joinTheCauseData, makeDifferenceData } from "./data";
import desi_hands from "./images/desi_hands.svg";
import desi_hands_hero from "./images/desi_hands_hero.svg";
import faq_img from "./images/faq.svg";
import modal_cross from "./images/modal_cross.svg";

const DesiHands = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [activeExpandIndex, setActiveExpandIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState({
        id: "",
        title: "",
        description: ``,
        image: "",
    });

    return (
        <Layout title="Desi Hands">
            <div className="container">
                <BreadCrumb
                    list={[
                        { name: "Home", link: "/" },
                        { name: "Desi Hands", link: "/desi-hands" },
                    ]}
                />

                <div className={styles.desi_hand}>
                    <img src={desi_hands} alt="desi_hands" />
                    <p>Share with Underprivileged Children</p>
                </div>

                <div className={styles.hero}>
                    <img src={desi_hands_hero} alt="desi_hands_hero" />
                    <div className="fs-3">Nurturing the Next Generation with Desi Fresh's 'Desi Hands' Initiative</div>
                </div>

                <div className={styles.ep}>
                    <div className={styles.ep_title}>Every Purchase Makes a Difference</div>
                    <div className={styles.ep_desc}>
                        "At Desi Fresh, we believe that <strong>every child deserves a brighter future</strong> , filled with opportunities
                        for growth and development. That's why we've created our 'Desi Hands' initiative, which{" "}
                        <strong>supports underprivileged kids</strong> through providing access to clean drinking water, medication, food,
                        and education. By choosing to purchase your groceries from Desi Fresh, you'll not only enjoy the best in
                        multicultural ingredients and flavors, but also make a positive impact on the world around you.{" "}
                        <strong>Empower the next generation</strong> and <strong>make a difference</strong> with every purchase from Desi
                        Fresh."
                    </div>
                </div>

                <div className={styles.join_cause}>
                    <div className={styles.join_cause_title}>Join the Cause</div>
                    <Row gutter={[20, 20]}>
                        {joinTheCauseData.map((item, index) => (
                            <Col xs={24} sm={12} md={8} lg={6} key={index}>
                                <div className={styles.join_cause_item}>
                                    <img src={item.image} alt="banner" className="img-fluid" loading="lazy" />
                                    <h3>{item.title}</h3>
                                    {isExpanded && index === activeExpandIndex ? (
                                        <div className="px-2 text-center">
                                            <div>{item.description}</div>
                                            <span
                                                className="fw-bold text-decoration-underline text-primary"
                                                role="button"
                                                onClick={() => {
                                                    if (window.innerWidth < 576) {
                                                        setIsExpanded(false);
                                                    }
                                                }}
                                            >
                                                Read Less
                                            </span>
                                        </div>
                                    ) : (
                                        <div className="px-2 text-center">
                                            {" "}
                                            {item.description.slice(0, 165)}...{" "}
                                            <span
                                                className="fw-bold text-decoration-underline"
                                                role="button"
                                                onClick={() => {
                                                    if (window.innerWidth < 576) {
                                                        setIsExpanded(true);
                                                        setActiveExpandIndex(index);
                                                    } else {
                                                        setIsModalOpen(true);
                                                        setModalData(item);
                                                    }
                                                }}
                                            >
                                                Read More
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </Col>
                        ))}
                    </Row>
                    <Modal
                        open={isModalOpen}
                        onCancel={() => {
                            setIsModalOpen(false);
                        }}
                        centered
                        footer={null}
                        closeIcon={
                            <img
                                src={modal_cross}
                                alt="close"
                                className="img-fluid"
                                style={{
                                    height: 32,
                                }}
                            />
                        }
                        destroyOnClose
                    >
                        <div className="d-flex flex-column text-center">
                            <img src={modalData.image} alt="cause_pic" className="img-fluid" loading="lazy" />
                            <div className="text-primary fs-2 fw-bold mt-3">{modalData.title}</div>
                            <div>{modalData.description}</div>
                        </div>
                    </Modal>
                </div>
            </div>

            <div className="container pt-4">
                <div className={styles.empower_future}>
                    <div className={styles.empower_future_title}>Empowering the Future</div>
                    <div className={styles.empower_future_subtitle}>Make a Difference for Children in Need</div>

                    <Row gutter={[12, 12]}>
                        {empowerFutureData.map((item, index) => (
                            <Col xs={24} sm={12} md={8} lg={6} key={index}>
                                <div className={styles.empower_future_item}>
                                    <img src={item.image} alt="item_image" className="img-fluid" loading="lazy" />
                                    <div className={styles.empower_future_item_title}>{item.title}</div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>

            <div className="container pt-4">
                <div className={styles.md_title}>Make a Difference in the World</div>
                <div className={styles.md_subtitle}>Together, we have the power to create a brighter future for children in need</div>
                <Row gutter={[15, 15]}>
                    {makeDifferenceData.map((item, index) => (
                        <Col xs={24} sm={12} md={8} lg={6} key={index}>
                            <div className={styles.md_item}>
                                <img src={item.banner} alt="banner" className="img-fluid" loading="lazy" />
                                <div className={styles.flag_country}>
                                    <img src={item.flag} alt="flag" />
                                    <div> {item.country} </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
            {/* faq */}
            <div className={`${styles.faq_wrapper} container`}>
                <div className={styles.faq_title}>
                    <img src={faq_img} alt="faq_img" />
                    <div>Frequently Asked Questions</div>
                </div>
                <div className={styles.faq_subtitle}>Here are the answers to your most common questions.</div>

                <div className={styles.cf}>
                    <div>Can't find the answer? Message us your question via </div>
                    <Button type="primary" className="mt-2">
                        <Link to={"/"} className="text-decoration-none">
                            Contact us
                        </Link>
                    </Button>
                </div>

                <div className={styles.questions}>
                    <Collapse
                        accordion={true}
                        ghost={true}
                        expandIcon={({ isActive }) => <DownOutlined size={20} rotate={isActive ? 180 : 0} />}
                        bordered={false}
                        expandIconPosition="end"
                    >
                        {faqData.map((item) => (
                            <Collapse.Panel header={<span> {item.question} </span>} key={item.id}>
                                <span>{item.answer}</span>
                            </Collapse.Panel>
                        ))}
                    </Collapse>
                </div>
            </div>

            {/* <div className={styles.wrapper}>
                <div className={styles.gi_title}>Get involved</div>
                <GetInvolvedForm />

                <div className={styles.cs}>
                    <div className={styles.cs_title}>Want to speak with our customer support ?</div>

                    <div className={styles.cs_call}>
                        <img src={call} alt="call" />
                        <div>
                            Hotline (Mo. -Sa. 8 -20 Hrs.) <br /> Monday - Friday 10:00 -20:00 <br />{" "}
                            <span style={{ fontSize: 18, fontWeight: "600" }}> (+49) 8161-491651</span>
                        </div>
                    </div>
                    <div className={styles.cs_map}>
                        <img src={map} alt="map" />
                        <div>
                            Königsteinstraße 1/3, 80807 <br /> München Germany
                            <br />
                            <br />
                            Sonnenstraße 7a, 85764 <br /> Oberschleißheim Germany
                        </div>
                    </div>
                    <div className={styles.cs_mail}>
                        <img src={mail} alt="mail" />
                        <div>support@desifresh.co</div>
                    </div>
                </div>
            </div> */}
            <br />
        </Layout>
    );
};

export default DesiHands;

// const GetInvolvedForm = () => {
//     const onFinish = (values) => {
//         console.log("Success:", values);
//     };

//     return (
//         <Form
//             initialValues={{
//                 title: "Mr.",
//             }}
//             onFinish={onFinish}
//             autoComplete="off"
//             layout="vertical"
//             requiredMark={false}
//             style={{
//                 width: "100%",
//             }}
//             scrollToFirstError={true}
//         >
//             <Row gutter={[20, 0]}>
//                 <Col xs={12}>
//                     <Form.Item label="Title" name="title">
//                         <Select>
//                             <Select.Option value={"Mr."}>Mr.</Select.Option>
//                             <Select.Option value={"Mrs."}>Mrs.</Select.Option>
//                         </Select>
//                     </Form.Item>
//                 </Col>

//                 <Col xs={12}></Col>

//                 <Col xs={12}>
//                     <Form.Item
//                         label="First Name *"
//                         name="first_name"
//                         rules={[
//                             {
//                                 required: true,
//                                 message: "Please enter your first name!",
//                             },
//                         ]}
//                     >
//                         <Input type={"text"} />
//                     </Form.Item>
//                 </Col>
//                 <Col xs={12}>
//                     <Form.Item
//                         label="Last Name *"
//                         name="last_name"
//                         rules={[
//                             {
//                                 required: true,
//                                 message: "Please enter your last name!",
//                             },
//                         ]}
//                     >
//                         <Input type={"text"} />
//                     </Form.Item>
//                 </Col>

//                 <Col xs={24}>
//                     <Form.Item
//                         name="email"
//                         label="Email Address *"
//                         rules={[
//                             {
//                                 type: "email",
//                                 message: "The input is not valid Email!",
//                             },
//                             {
//                                 required: true,
//                                 message: "Please enter your Email!",
//                             },
//                         ]}
//                     >
//                         <Input />
//                     </Form.Item>
//                 </Col>

//                 <Col xs={24}>
//                     <Form.Item
//                         label="Select a cause *"
//                         name="cause"
//                         rules={[
//                             {
//                                 required: true,
//                                 message: "Please select a cause",
//                             },
//                         ]}
//                     >
//                         <Select placeholder="Select a cause">
//                             <Select.Option value={"clean_drinking_water"}>Clean drinking water</Select.Option>
//                             <Select.Option value={"food_nutrition"}>Food and Nutrition</Select.Option>
//                             <Select.Option value={"education"}>Education</Select.Option>
//                             <Select.Option value={"healthcare"}>Healthcare</Select.Option>
//                             <Select.Option value={"all"}>All of the above</Select.Option>
//                         </Select>
//                     </Form.Item>
//                 </Col>

//                 <Col sm={24} xs={24}>
//                     <Form.Item
//                         label="Your Message *"
//                         name="message"
//                         rules={[
//                             {
//                                 required: true,
//                                 message: "Please enter your message!",
//                             },
//                         ]}
//                     >
//                         <Input.TextArea type={"text"} rows={4} placeholder="Your message here..." />
//                     </Form.Item>
//                 </Col>

//                 <Col sm={24}>
//                     <Form.Item
//                         name="agreement"
//                         valuePropName="checked"
//                         rules={[
//                             {
//                                 validator: (_, value) =>
//                                     value ? Promise.resolve() : Promise.reject(new Error("Please accept agreement!")),
//                             },
//                         ]}
//                     >
//                         <Checkbox>
//                             I agree to process my personal data in accordance with the Desi Fresh{" "}
//                             <Link to="/data-protection" className={styles.form_ck}>
//                                 Data Protection Policy
//                             </Link>
//                             . You can{" "}
//                             <a href="/" className={styles.form_ck}>
//                                 unsubscribe
//                             </a>{" "}
//                             anytime you do not wish to receive any information about products and promotions from Desi Fresh.
//                         </Checkbox>
//                     </Form.Item>
//                 </Col>

//                 <Col sm={24} xs={24}>
//                     <Form.Item>
//                         <Button loading={false} htmlType="submit" style={{ padding: "0 4rem" }} type="primary">
//                             Send Now
//                         </Button>
//                     </Form.Item>
//                 </Col>
//             </Row>
//         </Form>
//     );
// };
